import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ERROR_HANDLER_ENABLED, ROUTER_URLS } from '@portal/common';
import { catchError, Observable, throwError } from 'rxjs';

export const errorHandlerInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const router = inject(Router);

  return next(req).pipe(
    /** 
 * For testing purposes, you can uncomment the following code block to simulate a 500 error.
     switchMap(() =>
      throwError(
        () =>
          new HttpErrorResponse({
            error: 'Internal Server Error 500',
            status: 500,
            statusText: 'Internal Server Error',
          }),
      ),
    ), */
    catchError((err) => {
      if (err instanceof HttpErrorResponse) {
        const errorHandlerEnabled = req.context?.get(ERROR_HANDLER_ENABLED);

        if (errorHandlerEnabled) {
          switch (err.status) {
            case 400:
            case 500:
              console.warn('handled error', err);
              router.navigate([ROUTER_URLS.root, ROUTER_URLS.error500]);
              break;

            case 404:
              console.warn('handled error', err);
              router.navigate([ROUTER_URLS.root, ROUTER_URLS.error404]);
              break;

            default:
              console.warn('Unhandled error', err);
          }
        }
      }

      return throwError(() => err);
    }),
  ) as unknown as Observable<HttpEvent<unknown>>;
};
